"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
require("./styles.css");
var LoadingAnimation = function (_a) {
    var _b = _a.loadingMessage, loadingMessage = _b === void 0 ? 'Loading...' : _b, restProps = __rest(_a, ["loadingMessage"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: "loading-animation loading-container" }),
        react_1["default"].createElement("div", { className: "loading-animation loading-bars" },
            react_1["default"].createElement("div", null),
            react_1["default"].createElement("div", null),
            react_1["default"].createElement("div", null)),
        react_1["default"].createElement("div", { className: "loading-animation loading-text" }, loadingMessage)));
};
exports["default"] = LoadingAnimation;
